/* ---
	Product compare related products
	Expand/collapse for the comparison rows, the highlight differences toggle
	and the "Read more" clamp on long ingredients cells.
--- */

if (typeof ProductCompareRelatedProducts !== 'function') {
	class ProductCompareRelatedProducts extends HTMLElement {
		connectedCallback() {
			this.toggleButton = this.querySelector('[data-compare-related-toggle]');
			this.highlightToggle = this.querySelector('[data-compare-highlight-toggle]');

			if (this.toggleButton) {
				this.toggleButton.addEventListener('click', () => {
					const expanded = this.classList.toggle('product-compare-related--expanded');
					this.toggleButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');

					if (!expanded) {
						this.scrollIntoView({ behavior: 'smooth', block: 'start' });
					}

					// Extra rows (incl. ingredients) may have just become visible.
					this.measureClamps();
				});
			}

			if (this.highlightToggle) {
				this.highlightToggle.addEventListener('change', () => {
					this.classList.toggle('product-compare-related--highlight', this.highlightToggle.checked);
				});
			}

			this.initClamps();
		}

		disconnectedCallback() {
			if (this.clampObserver) {
				this.clampObserver.disconnect();
				this.clampObserver = null;
			}

			if (this.onClampResize) {
				window.removeEventListener('resize', this.onClampResize);
				this.onClampResize = null;
			}
		}

		/**
		 * "Read more" clamp on long text cells (ingredients). The text is
		 * clamped with CSS line-clamp; the toggle is only revealed when the
		 * clamped text actually overflows, and is re-measured whenever the
		 * cell resizes (column widths change, hidden rows become visible).
		 */
		initClamps() {
			this.clamps = Array.from(this.querySelectorAll('[data-compare-clamp]'));
			if (!this.clamps.length) return;

			this.clamps.forEach((clamp) => {
				const toggle = clamp.querySelector('[data-compare-clamp-toggle]');
				if (!toggle) return;

				toggle.addEventListener('click', () => {
					const expanded = clamp.classList.toggle('product-compare-related__clamp--expanded');
					toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
				});
			});

			this.measureClamps();

			if ('ResizeObserver' in window) {
				this.clampObserver = new ResizeObserver(() => this.measureClamps());
				this.clamps.forEach((clamp) => this.clampObserver.observe(clamp));
			} else {
				this.onClampResize = () => this.measureClamps();
				window.addEventListener('resize', this.onClampResize);
			}
		}

		measureClamps() {
			if (!this.clamps) return;

			this.clamps.forEach((clamp) => {
				if (clamp.classList.contains('product-compare-related__clamp--expanded')) return;

				const text = clamp.querySelector('.product-compare-related__clamp-text');
				const toggle = clamp.querySelector('[data-compare-clamp-toggle]');
				if (!text || !toggle) return;

				// Not rendered yet (e.g. inside a collapsed extra row) - leave as is.
				if (text.clientHeight === 0) return;

				toggle.hidden = text.scrollHeight <= text.clientHeight + 1;
			});
		}
	}

	if (typeof customElements.get('product-compare-related') == 'undefined') {
		customElements.define('product-compare-related', ProductCompareRelatedProducts);
	}
}
